// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---_CUap","changedRecordsList":"changedRecordsList---k_QQV","changedRecord":"changedRecord---RtMM3"};